export type DanceOffTieBreak = 'none' | 'random' | 'dj_picks' | 'all_win';

export function tallyDanceOffVotes(
  votes: { contestant: number }[],
  contestantCount: number,
): { counts: number[]; totalVotes: number } {
  const counts = new Array<number>(contestantCount).fill(0);
  let totalVotes = 0;
  for (const vote of votes) {
    if (!Number.isInteger(vote.contestant) || vote.contestant < 1 || vote.contestant > contestantCount) continue;
    counts[vote.contestant - 1] += 1;
    totalVotes += 1;
  }
  return { counts, totalVotes };
}

export function findLeaders(counts: number[]): number[] {
  const max = Math.max(0, ...counts);
  if (max === 0) return [];
  const leaders: number[] = [];
  counts.forEach((count, index) => {
    if (count === max) leaders.push(index + 1);
  });
  return leaders;
}

export const DANCE_OFF_RESULT_SHOWN_MS = 15 * 60 * 1000;

// The DJ panel opens on the last result (and its claim QR) only while it is recent; after that it opens on setup
export function isDanceOffResultCurrent(closedAt: string | null, nowMs: number): boolean {
  if (!closedAt) return false;
  const closedMs = Date.parse(closedAt);
  if (Number.isNaN(closedMs)) return false;
  return nowMs - closedMs < DANCE_OFF_RESULT_SHOWN_MS;
}

export function winnersLabel(contestants: number[]): string {
  if (contestants.length === 0) return 'No winner';
  if (contestants.length === 1) return `Contestant ${contestants[0]}`;
  const head = contestants.slice(0, -1).join(', ');
  return `Contestants ${head} and ${contestants[contestants.length - 1]}`;
}

export function resolveWinners(
  leaders: number[],
  tieBreak: DanceOffTieBreak,
  options: { djPick?: number; randomIndex: (n: number) => number },
): number[] {
  if (leaders.length === 0) return [];
  if (leaders.length === 1) return [leaders[0]];

  switch (tieBreak) {
    case 'random':
      return [leaders[options.randomIndex(leaders.length)]];
    case 'dj_picks':
      if (options.djPick === undefined || !leaders.includes(options.djPick)) {
        throw new Error(`Contestant ${options.djPick} is not tied for the lead`);
      }
      return [options.djPick];
    case 'all_win':
      return [...leaders];
    case 'none':
      throw new Error('A tie needs a tie-break');
  }
}
